type Props = {
  title: string;
  short?: string | null;
  weekstart: string; // YYYY-MM-DD
  weekend: string; // YYYY-MM-DD
  reward: "kódkártya" | "1 pont" | "2 pont" | "3 pont" | "1kk" | string;
};

export default function XChallengeCard({
  title,
  short,
  weekstart,
  weekend,
  reward,
}: Props) {
  const isGolden = reward.trim().toLowerCase() === "1kk";

  return (
    <div
      className={`challenge-card ${isGolden ? "challenge-card--golden" : ""}`}
    >
      <h3>{title}</h3>

      {short && <p>{short}</p>}

      <div className="reward-badge" aria-label={`Reward: ${reward}`}>
        {reward}
      </div>
    </div>
  );
}